import { shallowEqual, useSelector } from 'react-redux'
import { selectCurrentMerchantUser } from 'selectors/merchantUser'

export default function useCurrentMerchantUser() {
  return useSelector(selectCurrentMerchantUser, shallowEqual)
}
